import React from "react";
import { ButtonGroup } from "reactstrap";

export default ({children, config}) => {
  return <ButtonGroup>{children}</ButtonGroup>;
};
